// extracted by mini-css-extract-plugin
export var content = "index-module--content--Q5OA3";
export var decimalList = "index-module--decimalList--wMpDn";
export var discList = "index-module--discList--j4F-W";
export var sectionTitle = "index-module--sectionTitle--xGqyp";